const useFullDate = (date) => {
    const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
    ];
    const dateArray = date.split('/');
    return (
        dateArray[0] +
        ' de ' +
        months[parseInt(dateArray[1]) - 1] +
        ' de ' +
        dateArray[2]
    );
};
export default useFullDate;
